import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import RotateItemCommand from '../command/rotateItemCommand';
import DropdownField from './dropdownField';

/**
 * @class RotationSelectField
 */
export default class RotationSelectField extends DropdownField {
    type = 'rotationSelect';
    supports = 'supportsRotation';

    /**
     * Register click event on dropdown.
     *
     * @param {jQuery} dropdown
     */
    registerEventsForDropdown(dropdown) {
        dropdown.on('click', 'li a', this.onChangeSize.bind(this));
    }

    /**
     * @param {Event} event
     */
    onChangeSize(event) {
        const newRotation = $(event.target).data('item');
        const history = this.editor.getCanvas().getHistory();

        const command = new RotateItemCommand(this.currentItem, newRotation);

        history.addAndExecuteCommand(command);

        event.preventDefault();
    }

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateText(item) {
        const rotation = item.get('rotation');
        this.button.children('.text').text(`${rotation}°`);
    }

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateOptions(item) {
        const options = item
            .supportedRotationSteps
            .map(step => ({
                key: step,
                value: `${step}°`,
                active: step === item.get('rotation'),
            }));

        this.setOptions(options);
    }

    /**
     * Check if field is supported by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1
            && item
            && item.supportsRotation
            && item.supportsSnappedRotation()
            && !item.supportsFreeRotation;
    }
}
